
import { DashboardImageAlign, DashboardImageData } from "@/utils/dashboard/dashboard-image-data";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppFileUploadDropAndProgress from "@/components/FileUploadDropAndProgress.vue";
import { AuthService, AWSFileService } from "@/services";
import { AWSFile } from "@/models/aws-file";
import { ISelectItem } from "winfakt-vue-components";
import AppColorPicker from "@/components/ColorPicker.vue";

export default Vue.extend({
	data(){
		return {
			data: new DashboardImageData(),
			uploadingImage: false,
			images: [] as AWSFile[]
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		},
	},
	computed: {
		allowedExtensions(): string[] {
			return ["jpg", "png", "jpeg", "gif"];
		},
		pathPrefix():string{
			return `/dashboard/user/${AuthService.wfUser.ID}/images`;
		},
		uploadDisabled():boolean {
			return this.images.length >= 20;
		},
		items():ISelectItem<string>[] {
			return this.images.map(i=>{
				return {
					text: i.Name,
					value: i.Token,
				};
			});
		},
		confirmDisabled():boolean {
			return this.data.AWSImageToken == "";
		},
		alignItems():ISelectItem<DashboardImageAlign>[]{
			return [
				{
					text: this.$ct("align-start"),
					value: DashboardImageAlign.Start
				},
				{
					text: this.$ct("align-center"),
					value: DashboardImageAlign.Middle,
				},
				{
					text: this.$ct("align-end"),
					value: DashboardImageAlign.End
				}
			];
		}
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data){
					this.data =  new DashboardImageData();
					return;
				}
				this.data = new DashboardImageData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		},
		async onImageDrop(event:File){
			try{
				this.uploadingImage = true;
				let result = await AWSFileService.uploadFile(`${this.pathPrefix}`, event);
				this.images.push(result);
				this.data.AWSImageToken = result.Token;
			}catch(err){

			}finally{
				this.uploadingImage = false;
			}
		},
		async fetchImages(){
			this.images = await AWSFileService.listFiles(this.pathPrefix);
		},
		selectImage(image:AWSFile){
			this.data.AWSImageToken = image.Token;
		},
		async deleteImage(img:AWSFile){
			await AWSFileService.deleteFiles([img]);
			await this.fetchImages();
		}
	},
	async mounted(){
		await this.fetchImages();
	},
	components: {
		AppFileUploadDropAndProgress,
		AppColorPicker,
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}
});
